import { getRandomInt } from "../helpers";
import { message } from "./message";
export function checkIntegrity() {
    const M = 60000;
    if ((process.env.TRIALPACKAGE || process.env.SITEPACKAGE) && isValid())
        return;
    setTimeout(() => {
        if (process.env.TRIALPACKAGE) {
            setInterval(() => {
                if (typeof window !== "undefined" &&
                    new Date() > process.env.TRIALDATE) {
                    //"Your trial has expired. Please purchase the commercial license for the ToDo List widget at https://dhtmlx.com"
                    const str = window.atob("WW91ciB0cmlhbCBoYXMgZXhwaXJlZC4gUGxlYXNlIHB1cmNoYXNlIHRoZSBjb21tZXJjaWFsIGxpY2Vuc2UgZm9yIHRoZSBUb0RvIExpc3Qgd2lkZ2V0IGF0IGh0dHBzOi8vZGh0bWx4LmNvbQ==");
                    message(str);
                }
            }, getRandomInt(M, M * 3));
        }
        if (process.env.SITEPACKAGE) {
            setInterval(() => {
                //"This version of ToDo List is intended for demonstration only. Download an official evaluation version to try widget in your project at https://dhtmlx.com"
                const str = window.atob("VGhpcyB2ZXJzaW9uIG9mIFRvRG8gTGlzdCBpcyBpbnRlbmRlZCBmb3IgZGVtb25zdHJhdGlvbiBvbmx5LiBEb3dubG9hZCBhbiBvZmZpY2lhbCBldmFsdWF0aW9uIHZlcnNpb24gdG8gdHJ5IHdpZGdldCBpbiB5b3VyIHByb2plY3QgYXQgaHR0cHM6Ly9kaHRtbHguY29t");
                message(str);
            }, getRandomInt(M, M * 3));
        }
    });
}
function isValid() {
    if (typeof window === "undefined")
        return true;
    const l = location.hostname;
    const t = [
        // dhtmlx.com
        "ZGh0bWx4LmNvbQ==",
        // dhtmlxcode.com
        "ZGh0bWx4Y29kZS5jb20=",
        // webixcode.com
        "d2ViaXhjb2RlLmNvbQ==",
        // webix.io
        "d2ViaXguaW8=",
        // repl.co
        "cmVwbC5jbw==",
        // csb.app
        "Y3NiLmFwcA==",
    ];
    for (let i = 0; i < t.length; i++) {
        const x = window.atob(t[i]);
        if (x === l || l.endsWith("." + x))
            return true;
    }
    return false;
}
//# sourceMappingURL=package.js.map